import { Close } from "@mui/icons-material";
import { Box, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React from "react";
import useAppGlobal from "src/context/useAppGlobal";
import useConfirmBulkReturnProcessing from "src/hooks/orders/bulk-return-processing/useConfirmBulkReturnProcessing";
import useDetailBulkReturnProcessing from "src/hooks/orders/bulk-return-processing/useDetailBulkReturnProcessing";
import useRemoveBulkReturnDetail from "src/hooks/orders/bulk-return-processing/useRemoveBulkReturnDetail";

const BulkReturnItem = ({ item, no, confirmBtn }) => {
  const { trigger: remove } = useRemoveBulkReturnDetail(item?.returnLog, item?._id);

  const onRemove = async () => {
    const res = await remove();
    if (res?.success) {
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };
  return (
    <TableRow>
      <TableCell align="center">{no}</TableCell>
      <TableCell align="center">
        {item?.productModel?.product?.name} - {item?.productModel?.name}
      </TableCell>
      <TableCell align="center">{item?.qty}</TableCell>
      <TableCell align="center">{item?.itemCode ?? "N/a"}</TableCell>
      {confirmBtn && (
        <TableCell align="center">
          <IconButton
            onClick={onRemove}
            variant="contained"
          >
            <Close sx={{ fontSize: "12px" }} />
          </IconButton>
        </TableCell>
      )}
    </TableRow>
  );
};

export default function BulkReturnListTable({ returnedFormId, confirmBtn = true }) {
  const { closeDialog } = useAppGlobal();
  const { data: bulkReturnList } = useDetailBulkReturnProcessing(returnedFormId);
  const { trigger: confirm } = useConfirmBulkReturnProcessing(returnedFormId);

  const onSubmit = async () => {
    const res = await confirm();
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  return (
    <Box
      height="100%"
      display="flex"
      justifyContent="space-between"
      flexDirection="column"
    >
      <Box bgcolor="var(--light-grey)">
        <TableContainer>
          <Table
            sx={{ minWidth: 650 }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold" }}
                >
                  STT
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold" }}
                >
                  Tên SP
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold" }}
                >
                  SL
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold" }}
                >
                  Số serial
                </TableCell>
                {confirmBtn && (
                  <TableCell
                    align="center"
                    sx={{ fontWeight: "bold" }}
                  >
                    Thao tác
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(bulkReturnList?.data?.returnLogDetails) ? (
                bulkReturnList?.data?.returnLogDetails?.map((v, i) => {
                  return (
                    <BulkReturnItem
                      no={i + 1}
                      item={v}
                      key={v?._id}
                      confirmBtn={confirmBtn}
                    />
                  );
                })
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={10}
                    sx={{ textAlign: "center" }}
                  >
                    Dữ liệu chưa được tìm thấy
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      {confirmBtn && (
        <Button
          disabled={!returnedFormId || !bulkReturnList?.data?.returnLogDetails?.length}
          onClick={onSubmit}
          fullWidth
          variant="contained"
        >
          Xác nhận
        </Button>
      )}
    </Box>
  );
}
